import { render, staticRenderFns } from "./info-warning.vue?vue&type=template&id=df3ca8a6"
import script from "./info-warning.vue?vue&type=script&lang=js"
export * from "./info-warning.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports